<script setup>
import HeadingTwo from '@/Components/HeadingTwo.vue'
import HeadingThree from '@/Components/HeadingThree.vue'
import Paragraph from '@/Components/Paragraph.vue'

const features = [
    {
        name: '🌍 Online zpracování',
        description: 'Vše vyřešíte pohodlně z domova. Žádné fronty, schůzky nebo zbytečné papírování.',
        imageSrc: 'src/hero/2.png',
        imageAlt: 'White canvas laptop sleeve with gray felt interior, silver zipper, and tan leather zipper pull.',
    },
    {
        name: '👶 Snadné',
        description:
            'Nemusíte být účetní ani odborník. Naše služba je přehledná a navede vás krok za krokem. Vyplníte jen potřebné údaje a během pár minut máte hotovo.',
        imageSrc: 'src/hero/3.png',
        imageAlt: 'White canvas laptop sleeve with gray felt interior, silver zipper, and tan leather zipper pull.',
    },
    {
        name: '💬 Vždy po ruce',
        description:
            'Jsme tu pro vás přes e-mail nebo chat. Rádi vám pomůžeme a vše vysvětlíme srozumitelně, abyste se vyhnuli jakýmkoliv komplikacím.',
        imageSrc: 'src/hero/9.png',
        imageAlt: 'White canvas laptop sleeve with gray felt interior, silver zipper, and tan leather zipper pull.',
    },
    {
        name: '✔ Skvělá cena',
        description:
            'Kvalitní zpracování nemusí být drahé. U nás získáte profesionální službu za férovou cenu, která nezatíží váš rozpočet.',
        imageSrc: 'src/hero/5.png',
        imageAlt: 'White canvas laptop sleeve with gray felt interior, silver zipper, and tan leather zipper pull.',
    },
    {
        name: '🕒 Šetříme váš čas',
        description:
            'Zapomeňte na dlouhé hodiny nad formuláři. Naše služba je navržena tak, abyste celý proces zvládli co nejrychleji, a ušetřený čas věnovali tomu, co máte opravdu rádi.',
        imageSrc: 'src/hero/7.png',
        imageAlt: 'White canvas laptop sleeve with gray felt interior, silver zipper, and tan leather zipper pull.',
    },
    {
        name: '📝 O vše se postaráme',
        description:
            'Vyplníte jen základní informace a my připravíme vaše přiznání, zkontrolujeme ho, vytvoříme přehledy pro pojišťovny a dodáme vám jasné pokyny k odeslání.',
        imageSrc: 'src/hero/4.png',
        imageAlt: 'White canvas laptop sleeve with gray felt interior, silver zipper, and tan leather zipper pull.',
    },
]
</script>

<template>
    <div class="section--width">
        <div class="mx-auto max-w-3xl text-center">
            <HeadingTwo> Proč si vybrat nás? </HeadingTwo>
        </div>

        <div class="mt-16 space-y-20">
            <div
                v-for="(feature, featureIdx) in features"
                :key="featureIdx"
                :id="feature.id"
                class="flex flex-col-reverse lg:grid lg:grid-cols-12 lg:items-center lg:gap-x-8"
            >
                <div
                    :class="[
                        featureIdx % 2 === 0 ? 'lg:col-start-1' : 'lg:col-start-8 xl:col-start-9',
                        'mt-6 lg:col-span-5 lg:row-start-1 lg:mt-0 xl:col-span-4 xl:p-4',
                        feature.border,
                    ]"
                >
                    <HeadingThree :value="feature.name" />

                    <Paragraph :value="feature.description" />
                </div>

                <div
                    :class="[
                        featureIdx % 2 === 0 ? 'lg:col-start-6 xl:col-start-5' : 'lg:col-start-1',
                        'grid h-full place-content-center lg:col-span-7 lg:row-start-1 xl:col-span-8',
                    ]"
                >
                    <img
                        :src="feature.imageSrc"
                        :alt="feature.imageAlt"
                        class="h-72 w-auto rounded-lg object-cover"
                    />
                </div>
            </div>
        </div>
    </div>
</template>
